const initialState = {
    id: null,
    avatar: null,
    name: null,
    isGroup: false,
};

const messages = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_RECEIVER': {
            return action.payload;
        }

        case 'CLEAR_RECEIVER': {
            return {
                id: null,
                avatar: null,
                name: null,
                role: null,
                isGroup: false,
            };
        }

        default: {
            return state;
        }
    }
};

export default messages;
